import service from '../utils/axios'
const baseUrl = process.env.VUE_APP_BASE_API + '/upload'
// 参数需

// 检测是否需要登录
export function checkLogin(id) {
  return new Promise((resolve, reject) => {
    service
      .post(`/iform/api/form/${id}/check-login`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 微信获得授权auth
export function getWxAuth(id, url) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/account/wechat-auth?form_id=' + id + '&redirect_uri=' + encodeURIComponent(url))
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 微信-自动登录获取token
export function getWxAuthCode(id, code) {
  const data = {
    form_id: id,
    code: code
  }
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/account/wechat-login', data)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 企业微信-自动登录获取token
export function getWxWorkAuthCode(id, code) {
  const data = {
    form_id: id,
    code: code
  }
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/account/work-wechat-login', data)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 枫桥登录获取token
export function getZfqAppUserToken(id, token) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/account/fengqiao-login?form_id=' + id + '&access_token=' + token)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 发送短信验证码
export function postSendMsg(mobile, token) {
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/sys/send-code', {
        mobile,
        token
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 查询表单信息
export function getRealFormInfo(id, token, code = '') {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/form/' + id + '?token=' + token + '&code=' + code)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 上传图片
export function postUploadImage(formData) {
  return new Promise((resolve, reject) => {
    service
      .post(baseUrl + '/api/images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 上传附件
export function postUploadAttach(formData) {
  return new Promise((resolve, reject) => {
    service
      .post(baseUrl + '/api/attach/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 上传视频
export function postUploadVideo(formData) {
  return new Promise((resolve, reject) => {
    service
      .post(baseUrl + '/api/videos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 表单提交
export function postSubmitForm(param) {
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/record', param)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 获得支付方式
export function getPayWay(id, token) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/form/' + id + '/paymentmode?token=' + token)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 发起支付
export function postFormPay(openid, order_id, payment_type) {
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/order/pay', {
        openid,
        order_id,
        payment_type
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 支付结果查询
export function getPayResult(id) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/order/' + id + '/payresult')
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 查询预览表单信息(暂存)
export function getPrevFormInfo(id) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/form-tmp/' + id)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 查询预览表单信息(正式)
export function getPrevInfoFormal(id) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/form-preview/' + id)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 查询表单首页信息
export function getFormIndexInfo(id, token, code = '') {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/form/' + id + '/index?token=' + token + '&code=' + code)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 查询表单提交记录
export function getFormRecord(page, pageSize, id, token) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/records?form_id=' + id + '&token=' + token + '&page=' + page + '&pagesize=' + pageSize)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 查询表单提交记录详情
export function getFormRecordInfo(recordId, id, token) {
  return new Promise((resolve, reject) => {
    service
      .get('/iform/api/record/' + recordId + '?form_id=' + id + '&token=' + token)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// // 查询表单有效期
// export function getFormValid(id, token) {
//   return new Promise((resolve, reject) => {
//     service
//       .get('/iform/api/form/' + recordId + '?form_id=' + id + '&token=' + token)
//       .then((res) => {
//         resolve(res)
//       })
//       .catch((error) => {
//         reject(error)
//       })
//   })
// }

// 查询微信分享配置
export function getWxConfig(data) {
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/account/wechat-js-sdk', data)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 获得上传图片uploadid
export function getUploadId() {
  return new Promise((resolve, reject) => {
    service
      .post('/iform/api/file/get-upload-id')
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 删除记录
export function deleteRecord(id) {
  return new Promise((resolve, reject) => {
    service
      .delete(`/iform/api/record/${id}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 获取图形验证码
export function getImgCode() {
  return new Promise((resolve, reject) => {
    service
      .get(`/iform/api/sys/img-code`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 发送短信验证码
export function sendCode(data) {
  return new Promise((resolve, reject) => {
    service
      .post(`/iform/api/sys/send-code`, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 相城总入口
export function szxcWxMiniCodeLogin(data) {
  return new Promise((resolve, reject) => {
    service
      .post(`/iform/api/account/szxc-login`, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 苏商通登陆
export function reqSstCodeLogin(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`/iform/api/account/sst-login`, params)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
